<template>
  <div class="shopping-cart" v-if="!isOnCartPage">
    <h3>{{ userName }} さんのカート</h3>
    <ul>
      <li v-for="item in cartItems" :key="item.product_id">
        {{ item.name }} - ¥{{ item.price }} x {{ item.quantity }}
        <button @click="removeFromCart(item.product_id)">削除</button>
      </li>
    </ul>
    <p>合計: ¥{{ cartTotal }}</p>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  name: 'ShoppingCart',
  setup() {
    const store = useStore();
    const route = useRoute();

    // カートアイテムと合計を計算
    const cartItems = computed(() => store.getters.cartItems);
    const cartTotal = computed(() => store.getters.cartTotal);
    const userName = computed(() => store.getters.userName); // Vuexからユーザー名を取得

    const removeFromCart = (productId) => {
      store.commit('removeFromCart', productId);
    };

    // 現在のルートがShoppingCartPageであるか確認
    const isOnCartPage = computed(() => {
      return route.name === 'ShoppingCartPage'; // ルート名を適切に指定
    });

    return {
      cartItems,
      cartTotal,
      removeFromCart,
      userName,
      isOnCartPage,
    };
  },
};
</script>

<style>
.shopping-cart {
  position: absolute;
  right: 20px;
  top: 20px;
  background: rgb(0, 0, 0);
  border: 1px solid #000000;
  padding: 10px;
  z-index: 1000;
}
</style>